module.exports = __webpack_public_path__ + "static/media/16_thetower.5f0dacdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/16_thetower.png
// module id = 79
// module chunks = 0